import React from "react";
import styles from '../../styles/onlineCounselling.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import { useRouter } from "next/router";
import { isFrappeOrJotFormClass } from "../../utils/helpers";
interface Props {
    studyabroadjdata: any;
    jotformId: number;
    externalLink:any;
}

const Studywithscholarship: React.FC<Props> = ({ studyabroadjdata, jotformId , externalLink}) => {
    const router = useRouter();
    return (
        <div id="study_scholarship" className={styles.studyabroadjourney} style={{ backgroundColor: studyabroadjdata?.sectionBgColor || "#FFF1EF" }}>
            <Container>
                <Row>
                    <div className={styles.heading}>
                        <h2>{studyabroadjdata.sectionTitle}</h2>
                    </div>
                </Row>
                <Row>
                    <Col xl={6} lg={6} md={6} sm={12} className={styles.worthgtrytext}>
                        <div className={styles.OffersContent}>
                            <div className={styles.ulItem}>
                                {
                                    studyabroadjdata?.sectionPoints?.length > 0 &&
                                    studyabroadjdata?.sectionPoints?.map((abroaddata: string, ind: number) => {
                                        return (
                                            <p key={ind}>{abroaddata}</p>
                                        )
                                    })
                                }
                            </div>
                            <div className={styles.anchor}>
                                <h5>Worth giving a try.</h5>
                                <a onClick={() => {
                                        !jotformId && router.push(externalLink)
                                       }}
                                        className={`${styles.btnReg}${jotformId
                                            ? ` ${isFrappeOrJotFormClass(jotformId)}`
                                            : ''
                                            }`}
                                    >
                                        { studyabroadjdata.button?.label || 'Register Now' }
                                    </a>
                            </div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className={styles.worthgtry} >
                        <div className={styles.stuImg}>
                            <CustomImage src={studyabroadjdata?.sectionImageUrl || "/images/degreegirl.png"} alt="whykc-icon-2.svg" width={450} height={360} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Studywithscholarship;